class FinancialStoriesEntity {
  constructor() {
    this.accountId = null;
    this.tileType = null;
    this.month = null;
    this.sumAmount = null;
    this.avgAmount = null;
    this.debitAmount = null;
    this.creditAmount = null;
    this.minAmount = null;
    this.transactionCount = null;
    this.transactions = null;
  }
  setTransactions(transaction) {
    this.transactions = transaction;
  }
  getTransactions() {
    return this.transactions;
  }
}

export default FinancialStoriesEntity;
